import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { AuthService } from "src/app/providers/auth.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddMemberComponent } from "src/app/shared/components/add-member/add-member.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { UpdateInterestStatusReplyComponent } from "../update-interest-status-reply/update-interest-status-reply.component";
import { DialogService } from "src/app/providers/dialog.service";
import { AddReplyForServiceQueryComponent } from "../add-reply-for-service-query/add-reply-for-service-query.component";
@Component({
  selector: "sm-service-query-details-page",
  templateUrl: "./service-query-details-page.component.html",
  styleUrls: ["./service-query-details-page.component.scss"],
})
export class ServiceQueryDetailsPageComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  serviceQueryDetail: any = [];
  loader: boolean = false;
  constructor(
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private navservice: NavigationService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    private router: Router
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      this.navservice.hideSidebarAndNav = false;
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_DETAILS
      ) {
        this.serviceQueryDetail = [];
        if (resdata.result) {
          this.serviceQueryDetail = resdata.result;

          this.serviceQueryDetail[0].entityInfo =
            typeof this.serviceQueryDetail[0].entityInfo == "string"
              ? JSON.parse(this.serviceQueryDetail[0].entityInfo)
              : this.serviceQueryDetail[0].entityInfo;
          this.serviceQueryDetail[0].profile_pic =
            typeof this.serviceQueryDetail[0].profile_pic == "string"
              ? JSON.parse(this.serviceQueryDetail[0].profile_pic)
              : this.serviceQueryDetail[0].profile_pic;

          if (this.serviceQueryDetail[0].status == 1) {
            this.serviceQueryDetail[0].item_status = "New";
          } else if (this.serviceQueryDetail[0].status == 2) {
            this.serviceQueryDetail[0].item_status = "In progress";
          } else if (this.serviceQueryDetail[0].status == 3) {
            this.serviceQueryDetail[0].item_status = "Marked as enrolled";
          } else if (this.serviceQueryDetail[0].status == 4) {
            this.serviceQueryDetail[0].item_status = "Cancelled";
          } else if (this.serviceQueryDetail[0].status == 5) {
            this.serviceQueryDetail[0].item_status = "Enrolled";
          } else {
            this.serviceQueryDetail[0].item_status = "---";
          }

          if (this.serviceQueryDetail[0].service_mode == 0) {
            this.serviceQueryDetail[0].s_mode = "Home service";
          } else if (this.serviceQueryDetail[0].service_mode == 1) {
            this.serviceQueryDetail[0].s_mode = "In-premise service";
          } else if (this.serviceQueryDetail[0].service_mode == 2) {
            this.serviceQueryDetail[0].s_mode = "Virtual service";
          }


          if(this.serviceQueryDetail[0].enquiry_type == 1){
            this.serviceQueryDetail[0].e_type = 'Booking'
          }
          else if(this.serviceQueryDetail[0].enquiry_type == 2){
            this.serviceQueryDetail[0].e_type = 'Membership'
          }
          else if(this.serviceQueryDetail[0].enquiry_type == 3){
            this.serviceQueryDetail[0].e_type = 'Payment'

          }
          else if(this.serviceQueryDetail[0].enquiry_type == 4){
            this.serviceQueryDetail[0].e_type = 'Feedback'

          }
          else if(this.serviceQueryDetail[0].enquiry_type == 5){
            this.serviceQueryDetail[0].e_type = 'Others'

          }
          console.log(this.serviceQueryDetail);
        }

        this.ls.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_PROGRESS_STATUS
      ) {
        if (resdata.result) {
          if (this.currentStatusOfChange == 3) {
            this.ls.showLoader = false;
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Success !",
                message:
                  "The status changed to Enrolled is successfully done. Do you want to add this person as a member now?",
                cancelbtn: "I'll do later",
                okbtn: "Add as member",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((res) => {
              if (res) {
                let data1 = {
                  title: "Add member",
                  ref: this.dialog,
                  data: {
                    entityHash: this.entityHash,
                    memberData: this.currentMemberOfChange,
                    // serviceType: this.interestType,
                  },
                };
                let dialogref = this.dialogService.openFullScreenDialog(
                  AddMemberComponent,
                  data1
                );
                dialogref.afterClosed().subscribe((res) => {
                  if (res) {
                    if (res.errorcode == 1) {
                      this.ls.showLoader = false;
                      const dialogRef = this.dialog.open(
                        CustomConfirmDialogComponent,
                        {
                          width: "500px",
                          data: {
                            title: "Alert",
                            message:
                              "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
                            okbtn: "Ok",
                            cancelbtn: "Cancel",
                            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                          },
                          disableClose: true,
                        }
                      );
                    } else if (res.errorcode == 2) {
                      this.ls.showLoader = false;
                      const dialogRef = this.dialog.open(
                        CustomConfirmDialogComponent,
                        {
                          width: "500px",
                          data: {
                            title: "Alert",
                            message:
                              "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
                            okbtn: "Ok",
                            cancelbtn: "Cancel",
                            type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                          },
                          disableClose: true,
                        }
                      );
                    } else {
                      // this.loader = true
                      this.ls.showLoader = true;
                      this.apiservice.getEnrollInterestDetailsById(
                        this.queryHash
                      );
                    }
                  } else {
                    this.ls.showLoader = true;
                    this.apiservice.getEnrollInterestDetailsById(
                      this.queryHash
                    );
                  }
                });
              } else {
                this.ls.showLoader = true;
                this.apiservice.getEnrollInterestDetailsById(this.queryHash);
              }
            });
          } else {
            this.apiservice.getEnrollInterestDetailsById(this.queryHash);
          }
        }
      }
     if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_ENQUIRY_PROGRESS_STATUS
      ) {
        if (resdata.result) {
          this.apiservice.getEntityEnquiryDetails(this.queryHash);
        }
      }
    });
  }

  queryHash: any;
  entityHash: any;
  eph: any;
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    // console.log(this.parentData);
    this.route.queryParams.subscribe((data) => {
      if (data.queryHash) {
        this.queryHash = data.queryHash;
        this.entityHash = data.entityHash;
        this.eph = data.eph;
        this.loader = true;
        this.ls.showLoader = true;
        this.apiservice.getEntityEnquiryDetails(this.queryHash);
      }
    });
  }

  getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  getProductsNames(products: any) {
    console.log(products);

    return products.map((product: any) => product.product_name).join(", ");
  }

  getCustomItemNames(cis: any) {
    console.log(cis);

    return cis.map((ci: any) => ci.item_name).join(", ");
  }

  formatSchedule(schedule: any[]) {
    return schedule.map((item) => {
      const weekday = this.getWeekdayString(item.weekday);
      const startTime = this.formatTime(item.start_time);
      const endTime = this.formatTime(item.end_time);
      return `${weekday}: ${startTime} - ${endTime}`;
    });
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

addReply(rowvalue: any) {
    let dialogRef = this.dialog.open(AddReplyForServiceQueryComponent, {
      width: "500px",
      data: {
        data: rowvalue,
        entityHash: this.entityHash,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        let data = {
          hash_id: rowvalue.hash_id,
          status: this.serviceQueryDetail[0].status ?? 1,
          reply: res.reply,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          creation_time: this.formatDateStringforcancel(new Date()),
          reply_date: this.formatDateStringforcancel(new Date())
        };
        Object.keys(data).forEach((key) => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });
        this.ls.showLoader = true;
        this.apiservice.updateEnityEnquiryProgressStatus(data);
      }
    });
  }

  currentStatusOfChange: any;
  currentMemberOfChange: any;
   changeRequestStatus(item: any, status: any) {
    let statusMessage = "";
    if (status == 1) {
      statusMessage = "Are you sure want to mark the query as new?";
    } else if (status == 2) {
      statusMessage = "Are you sure want to mark the query as in-progress?";
    } else if (status == 3) {
      statusMessage = "Are you sure want to mark the person as enrolled?";
    }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message: statusMessage,
        cancelbtn: "Cancel",
        okbtn: "Confirm",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.currentStatusOfChange = status;
        this.currentMemberOfChange = item;
        let data = {
          hash_id: item.hash_id,
          status: status,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          creation_time: this.formatDateStringforcancel(new Date()),
        };
        Object.keys(data).forEach((key) => {
                      if ((data as any)[key] === null) {
                        delete (data as any)[key];
                      }
                    });
        this.ls.showLoader = true;
        this.apiservice.updateEnityEnquiryProgressStatus(data);
      }
    });
  }

  addAsMember(item: any) {
    let data = {
      title: "Add member",
      ref: this.dialog,
      data: {
        entityHash: this.entityHash,
        memberData: item,
        // serviceType: this.interestType,
      },
    };

    let dialogref = this.dialogService.openFullScreenDialog(
      AddMemberComponent,
      data
    );
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.ls.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.ls.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 0) {
          if (res.whatsapp_share == 0 && res.email_share == 1) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation via WhatsApp as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          } else if (res.whatsapp_share == 1 && res.email_share == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation Email as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          } else if (res.whatsapp_share == 0 && res.email_share == 0) {
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
              width: "500px",
              data: {
                title: "Pack expired!",
                message:
                  "Enrolment successfully done for the new member. But unable to send the confirmation via Email and WhatsApp as Premium pack expired for this business. ",
                okbtn: "Buy pack",
                cancelbtn: "Cancel",
                type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
              },
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
              if (result) {
                this.router.navigate(
                  ["/businesses", "details", "plan-and-renew"],
                  {
                    queryParams: { entityHash: this.entityHash },
                  }
                );
              }
            });
          }
          this.ls.showLoader = true;
          this.apiservice.getEnrollInterestDetailsById(this.queryHash);
        }
      }
    });
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  deleteQuery(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this query?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          customerHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.ls.showLoader = true;
        this.apiservice.deleteEntityRequestData(obj);
      }
    });
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }


   formatDateStringforcancel(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
